export default __webpack_public_path__ + "static/media/45_4_1.c8b60310.png";